import React from "react"
import { concatStrings, getCategoryIconType } from "../utilities"
import { t } from "../../i18n-utility"
import DfbHeadline from "../ui-kit/dfb_headline"
import DfbAnchor from "../ui-kit/dfb_anchor"
import PageContext from "../page-context"
import DfbSymbol from "../ui-kit/dfb_symbol"
import DfbImage from "../ui-kit/dfb_image"
import { Transformation } from "cloudinary-react"
import CCardAuthor from "./c_card_author"
import { isPageAccessRestricted } from "../../helper/pageAccess.mjs"
import { withPrefix } from "gatsby"

const CEpaperCard = (props) => {
  return (
    <a
      className={concatStrings("dfb-Card", props.data.add_class)}
      href={withPrefix(props.data.full_slug)}
    >
      <div className="dfb-Card-icons">
        {props.data.content.root_categories &&
          props.data.content.root_categories.map((item) => (
            <div className="dfb-Card-icon" key={"icon" + item.title}>
              <DfbSymbol icon_type={getCategoryIconType(item)} />
            </div>
          ))}
      </div>
      {!props.data.hide_image && (
        <div className="dfb-Card-imageContainer">
          <DfbImage
            image={
              typeof props.data.content.titleimage === "string" &&
              props.data.content.titleimage !== ""
                ? { src: props.data.content.titleimage }
                : props.data.content.titleimage
            }
            add_class="dfb-Card-image"
            lazyload={props.force_image_loading ? false : true}
            aspect_ratio={
              props.data.image_aspect_ratio
                ? props.data.image_aspect_ratio
                : "16:9"
            }
          >
            <Transformation
              crop="fill"
              gravity="faces:center"
              width="800"
              height="450"
              quality="auto"
              fetchFormat="auto"
            />
          </DfbImage>
        </div>
      )}
      <div className="dfb-Card-content">
        <PageContext.Consumer>
          {({ translations }) => (
            <div className="dfb-Card-topline">
              {t(translations, "cards.study")}
            </div>
          )}
        </PageContext.Consumer>
        <DfbHeadline
          headline={props.data.name}
          noLevelClass="true"
          headline_level="h4"
          add_class="dfb-Card-headline"
        />

        {props.data.content.expert &&
          props.data.content.expert.show_on_card === "1" && (
            <CCardAuthor
              author={props.data.content.expert}
              force_image_loading={props.force_image_loading}
            />
          )}

        {props.data.content.card_callout &&
          props.data.content.card_callout !== "" && (
            <div className="dfb-Card-disturber">
              <div className="dfb-Icon dfb-Card-disturberIcon">
                <DfbSymbol icon_type="Information" />
              </div>
              <p className="dfb-Card-disturberContent">
                {props.data.content.card_callout}
              </p>
            </div>
          )}
      </div>
      <div className="dfb-Card-footer">
        <PageContext.Consumer>
          {({ translations }) => (
            <DfbAnchor
              tagName="div"
              secondary={true}
              text={t(translations, "dfb_anchor.studylink")}
              locked={isPageAccessRestricted(props.data)}
            />
          )}
        </PageContext.Consumer>
      </div>
    </a>
  )
}

export default CEpaperCard
